export const totalRecordByDateConstants = {
    GET_SUCCESS: 'GET_TOTAL_RECORD_BY_DATE_SUCCESS',
    GET_FAILURE: 'GET_TOTAL_RECORD_BY_DATE_FAILURE',
};

export const totalRecordByProjectConstants = {
    GET_SUCCESS: 'GET_TOTAL_RECORD_BY_PROJECT_SUCCESS',
    GET_FAILURE: 'GET_TOTAL_RECORD_BY_PROJECT_FAILURE',
};

export const totalRecordByDateConstants2 = {
    GET_SUCCESS: 'GET_TOTAL_RECORD_BY_DATE2_SUCCESS',
    GET_FAILURE: 'GET_TOTAL_RECORD_BY_DATE2_FAILURE',
};

export const projectEmployeeSortConstants = {
    GET_SUCCESS: 'GET_PROJECT_EMPLOYEE_SORT_SUCCESS',
};

export const departmentAndEmployeeConstants = {
    GET_SUCCESS: 'GET_DEPARTMENT_AND_EMPLOYEE_SUCCESS',
    GETTING: 'GETTING_SUCCESS_DEPARTMENT_AND_EMPLOYEE',
    GET_FAILURE: 'GET_DEPARTMENT_AND_EMPLOYEE_FAILURE',
}

export const departmentAndEmployeeConstantsExport = {
    GET_SUCCESS: 'GET_DEPARTMENT_AND_EMPLOYEE_EXPORT_SUCCESS',
    GET_FAILURE: 'GET_DEPARTMENT_AND_EMPLOYEE_EXPORT_FAILURE',
    DELETE: "GET_DELETE_EMPLOYEE",
}
